<template>
  <div class="info-box">
    <div class="overflow-y-auto">
      <ul class="flex">
        <li class="flex-1 font-bold">选择预付订单</li>
        <!-- <el-button color="#1e90ff" link @click="onChongXiaoDefault">
          自动填入
        </el-button> -->
      </ul>
      <el-radio-group v-model="state.supplier_payment_apply_id" class="!flex">
        <el-table
          :data="state.supplierPaymentApplyList"
          v-loading="!Array.isArray(state.supplierPaymentApplyList)"
          element-loading-background="rgba(0, 0, 0, 0.2)"
          @row-click="onRowClick"
        >
          <el-table-column fixed label="#" width="70" align="center">
            <template #default="{ row }">
              <el-radio :value="row.id"></el-radio>
            </template>
          </el-table-column>
          <el-table-column>
            <template #header>
              <div class="c-table-col-header" label1="状态" label2="预付单号" />
            </template>
            <template #default="{ row }">
              <c_tabgroup :value2="row.number">
                <template #top>
                  <c_status
                    arrName="Supplier_PaymentApply_Status"
                    :value="row.status"
                    :key="row.status"
                  />
                </template>
              </c_tabgroup>
            </template>
          </el-table-column>
          <el-table-column
            label="申请说明"
            prop="intro"
            align="center"
            :formatter="$tab_TextFormat"
          />
          <el-table-column label="预付金额" align="center">
            <template #default="{ row }">
              <text class="text-red-500">{{ $priceFormat(row.amount) }}</text>
            </template>
          </el-table-column>
          <el-table-column label="已冲销" align="center">
            <template #default="{ row }">
              <text class="text-blue-400">{{
                $priceFormat(row.traded_amount)
              }}</text>
            </template>
          </el-table-column>
          <el-table-column
            label="未冲销"
            prop="untrade_amount"
            :width="120"
            align="center"
            :formatter="$tab_MoneyFormat"
          >
            <template #default="{ row }">
              <c_money
                v-if="row.untrade_amount"
                :value="row.untrade_amount"
                :key="row.untrade_amount"
              />
              <text v-else>-</text>
            </template>
          </el-table-column>
          <!-- <el-table-column label="本次冲销" fixed="right" align="right">
            <template #default="{ row }">
              <el-input-number
                v-model="row.this_amount"
                :precision="2"
                class="number-input-left number-input-suffix !w-28"
                suffix="元"
                @focus="$onFocus"
                disabled
              ></el-input-number>
            </template>
          </el-table-column> -->
        </el-table>
      </el-radio-group>
      <ul class="flex mt-5">
        <li class="flex-1 font-bold">付款采购</li>
        <el-button color="#1e90ff" link @click="onFuKuanDefault">
          自动填入
        </el-button>
      </ul>
      <el-table
        :data="state.meetingPurchaseList"
        v-loading="!Array.isArray(state.meetingPurchaseList)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
      >
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          align="center"
        />
        <el-table-column :width="260">
          <template #header>
            <div
              class="c-table-col-header"
              label1="采购名称"
              label2="采购单号/类型/创建人"
            />
          </template>
          <template #default="{ row }">
            <c_tabgroup>
              <template #top>
                <strong>{{ row.name }}</strong>
                <text class="text-xs text-gray-400 ml-1">{{ row.number }}</text>
                <text class="text-xs text-gray-400 ml-1">
                  {{ row.d_cost_type_pname }}
                </text>
              </template>
              <template #bottom>
                <div class="flex items-center text-gray-400 text-xs gap-x-2">
                  <text class="text-sm text-gray-600">
                    {{ row?.add_admin_name }}
                  </text>
                  <text>{{ row?.add_department_name }}</text>
                  <text class="ml-1">{{ row?.create_time }} 创建</text>
                </div>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column :min-width="160">
          <template #header>
            <div
              class="c-table-col-header"
              label1="所属会议"
              label2="状态/项目编号"
            />
          </template>
          <template #default="{ row }">
            <c_tabgroup :value1="row.meeting?.name" :value2="row.number">
              <template #bottom>
                <div class="flex gap-x-2">
                  <c_status
                    arrName="Meeting_Status"
                    :value="row.meeting?.status"
                    :key="row.meeting?.status"
                  />
                  <text class="text-xs text-gray-400">{{
                    row.meeting?.number
                  }}</text>
                </div>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column label="结算价" :width="120" align="center">
          <template #default="{ row }">
            <text class="text-red-500">{{ $priceFormat(row.amount) }}</text>
          </template>
        </el-table-column>
        <el-table-column label="已付" :width="120" align="center">
          <template #default="{ row }">
            <text class="text-blue-400">{{
              $priceFormat(row.paid_amount)
            }}</text>
          </template>
        </el-table-column>
        <el-table-column
          label="应付"
          prop="unpaid_amount"
          :width="120"
          align="center"
          :formatter="$tab_MoneyFormat"
        />
        <el-table-column label="本次付款" fixed="right" align="right">
          <template #default="{ row }">
            <el-input-number
              v-model="row.this_amount"
              :precision="2"
              class="number-input-left number-input-suffix !w-28"
              suffix="元"
              @focus="$onFocus"
              @change="onFuKuanChange(row)"
            ></el-input-number>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="px-2.5 flex items-center mt-3">
      本次付款合计：<c_money
        class="flex-1"
        :key="state.fukuan_total"
        :value="state.fukuan_total"
        suffix
        :size="20"
      />
      <!-- 本次冲销合计：<c_money
        class="flex-1"
        :key="state.chongxiao_total"
        :value="state.chongxiao_total"
        suffix
        :size="20"
        color="#ffa500"
      /> -->
      <el-button type="primary" size="large" @click="onSubmit">
        提交冲销申请
      </el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  supplier_purchase_paymentTrade,
  supplier_purchase_paymentTradeSubmit,
} from "@/http/supplier";
import { ElMessage, ElMessageBox } from "element-plus";
import { toDecimal } from "@/utils/funcs";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  props: {
    supplier_id: Number,
    ids: Array,
  },
  setup(props, { emit }) {
    const state = reactive({
      ...new InitFormData(),
      model: {
        supplier_id: props.supplier_id,
        files: [],
      },
      meetingPurchaseList: [],
      supplierPaymentApplyList: [],
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      if (props.ids?.length > 0) {
        supplier_purchase_paymentTrade({
          supplier_id: props.supplier_id,
          meeting_purchase_id: props.ids,
        }).then((res) => {
          if (res.status == 200) {
            const { meetingPurchaseList, supplierPaymentApplyList } =
              res.data?.data;
            state.meetingPurchaseList = meetingPurchaseList;
            state.supplierPaymentApplyList = supplierPaymentApplyList;
          }
        });
      }
    };

    //金额更新
    const onFuKuanChange = (row) => {
      // if (state.supplier_payment_apply_id) {
      //   const item = state.supplierPaymentApplyList.find(
      //     (w) => w.id == state.supplier_payment_apply_id,
      //   );
      //   if (item && row.this_amount > item.untrade_amount) {
      //     ElMessage.warning("付款金额不能大于预付单冲销金额!");
      //     delete row.this_amount;
      //   }
      // }

      if (row.this_amount > row.unpaid_amount) {
        ElMessage.warning("付款金额不能大于应付金额!");
        delete row.this_amount;
      }
      onFuKuanTotal();
    };

    //计算合计
    const onFuKuanTotal = () => {
      const total = state.meetingPurchaseList.reduce((pre, cur) => {
        return pre.plus(toDecimal(cur.this_amount?.toString() || "0"));
      }, toDecimal("0"));
      state.fukuan_total = total;
    };

    //自动填写本次付款金额
    const onFuKuanDefault = () => {
      if (!state.supplier_payment_apply_id) {
        ElMessage.warning("请选择预付单");
        return false;
      }

      state.meetingPurchaseList.forEach((row) => {
        row.this_amount = row.unpaid_amount;
      });
      onFuKuanTotal();
    };

    const onRowClick = (item) => {
      state.supplier_payment_apply_id = item.id;
    };

    //金额更新
    const onChongXiaoChange = (row) => {
      if (row.this_amount > row.unpaid_amount) {
        ElMessage.warning("付款金额不能大于应付金额!");
        delete row.this_amount;
      }
      onChongXiaoTotal();
    };

    //计算合计
    const onChongXiaoTotal = () => {
      const total = state.supplierPaymentApplyList.reduce((pre, cur) => {
        return pre.plus(toDecimal(cur.this_amount?.toString() || "0"));
      }, toDecimal("0"));
      state.chongxiao_total = total;
    };

    //自动填写本次付款金额
    const onChongXiaoDefault = () => {
      state.supplierPaymentApplyList.forEach((row) => {
        row.this_amount = row.untrade_amount;
      });
      onChongXiaoTotal();
    };

    const onSubmit = () => {
      if (!state.supplier_payment_apply_id) {
        ElMessage.warning("请选择预付单");
        return false;
      }

      if (!state.fukuan_total) {
        ElMessage.warning("请填写本次付款金额");
        return false;
      }

      ElMessageBox.confirm(
        `本次冲销金额为<strong class='text-red-500'>${state.fukuan_total}元</strong>，是否确认冲销`,
        "申请付款",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          cancelButtonClass: "is-plain",
          type: "warning",
        },
      ).then(() => {
        supplier_purchase_paymentTradeSubmit({
          supplier_id: props.supplier_id,
          supplier_payment_apply_id: state.supplier_payment_apply_id,
          data: state.meetingPurchaseList?.map((m) => {
            return {
              meeting_purchase_id: m.id,
              this_amount: m.this_amount,
            };
          }),
        }).then((res) => {
          if (res.status == 200) {
            ElMessage.success("提交成功");
            emit("close");
          }
        });
      });
    };

    return {
      state,
      props,
      onLoad,
      onSubmit,
      onFuKuanChange,
      onFuKuanTotal,
      onFuKuanDefault,
      onChongXiaoChange,
      onChongXiaoTotal,
      onChongXiaoDefault,
      onRowClick,
    };
  },
};
</script>

<style lang="scss" scoped></style>
